import { PROFESSIONAL_USER_ROLE } from '../../../utils/constants';

// we need to write test for this
export const checkIsProfessionalUser = userType => {
  return PROFESSIONAL_USER_ROLE === userType;
};
